import * as React from 'react';

function LeftConfetti(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="487" height="125" viewBox="0 0 487 125" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#left_confetti_clip0)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M159 17.937C159 16.3154 160.319 15.0009 161.946 15.0009C163.574 15.0009 164.893 16.3154 164.893 17.937C164.893 19.5586 163.574 20.873 161.946 20.873C160.319 20.873 159 19.5586 159 17.937Z"
          fill="#DCEEF6"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M44.7896 21.2475C44.7896 19.6259 46.1087 18.3114 47.7359 18.3114C49.3631 18.3114 50.6821 19.6259 50.6821 21.2475C50.6821 22.8691 49.3631 24.1836 47.7359 24.1836C46.1087 24.1836 44.7896 22.8691 44.7896 21.2475Z"
          fill="#DCEEF6"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M125.71 0.488918L131.104 5.04632L124.305 7.82514L117.45 10.4455L118.744 3.24313L120.204 -3.93385L125.71 0.488918Z"
          stroke="#ADF9DA"
          strokeWidth="4"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M317.371 1.2481C317.371 -0.949199 319.158 -2.73035 321.363 -2.73035C323.568 -2.73035 325.355 -0.949198 325.355 1.2481C325.355 3.44541 323.568 5.22656 321.363 5.22656C319.158 5.22656 317.371 3.44541 317.371 1.2481Z"
          fill="#FA6C76"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M93.1033 20.9998L99.2807 24.9303L92.8411 28.2991L93.1033 20.9998Z"
          fill="#FA6C76"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M53.1033 90.9998L59.2807 94.9303L52.8411 98.2991L53.1033 90.9998Z"
          fill="#5194E0"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.07105 35.928L5.14284 42.9746L6.14832e-05 37.8495L7.07105 35.928Z"
          fill="#FA6C76"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M127.794 35.928L125.866 42.9746L120.723 37.8495L127.794 35.928Z"
          fill="#FA6C76"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32.0095 69.6358L36.1904 75.6348L28.9455 76.2709L32.0095 69.6358Z"
          fill="#FA6C76"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M413.554 14.0954C413.554 12.9939 414.45 12.101 415.555 12.101C416.661 12.101 417.557 12.9939 417.557 14.0954C417.557 15.1969 416.661 16.0898 415.555 16.0898C414.45 16.0898 413.554 15.1969 413.554 14.0954Z"
          fill="#DCEEF6"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M75.0001 55.9897C75.0001 53.7866 76.7921 52.0008 79.0027 52.0008C81.2134 52.0008 83.0054 53.7866 83.0054 55.9897C83.0054 58.1927 81.2134 59.9785 79.0027 59.9785C76.792 59.9785 75.0001 58.1927 75.0001 55.9897Z"
          fill="#F79EAA"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M274.857 5.78459C274.857 3.58155 276.649 1.79574 278.86 1.79574C281.071 1.79574 282.863 3.58155 282.863 5.78459C282.863 7.98763 281.071 9.77344 278.86 9.77344C276.649 9.77344 274.857 7.98763 274.857 5.78459Z"
          fill="#F79EAA"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M474.669 -2.41609L477.001 1.65635L468.925 6.35938L466.594 2.2863L474.669 -2.41609Z"
          fill="#EAC54F"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M377.121 4.78565C377.121 7.42944 374.97 9.57227 372.318 9.57227C369.665 9.57226 367.515 7.42944 367.515 4.78565C367.515 2.14186 369.665 -0.000961717 372.318 -0.000961485C374.97 -0.000961253 377.121 2.14186 377.121 4.78565Z"
          stroke="#5194E0"
          strokeWidth="4.268"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M82.6692 91.541L79.5197 87.4375L87.9362 81.2949L91.0864 85.3985L82.6692 91.541Z"
          fill="#EAC54F"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M222.284 3.60832L220.98 8.60845L210.94 5.78397L212.244 0.783279L222.284 3.60832Z"
          fill="#EAC54F"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.8144 117.394L17.2205 112.818L26.3581 117.834L23.9523 122.41L14.8144 117.394Z"
          fill="#EAC54F"
        />
      </g>
      <defs>
        <clipPath id="left_confetti_clip0">
          <rect width="487" height="125" fill="white" transform="translate(487 125) rotate(-180)" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default LeftConfetti;
